"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var Palette;

(function (Palette) {
  Palette["blue"] = "#54bfda";
  Palette["darkBlue"] = "#1c7f98";
  Palette["lightBlue"] = "#f4fdff";
  Palette["green"] = "#73ca33";
  Palette["darkGreen"] = "#42901a";
  Palette["lightGreen"] = "#ecfbe4";
  Palette["red"] = "#df5650";
  Palette["darkRed"] = "#b5312b";
  Palette["lightRed"] = "#fff2f1";
  Palette["yellow"] = "#deb126";
  Palette["darkYellow"] = "#a8810a";
  Palette["lightYellow"] = "#fffaeb";
  Palette["orange"] = "#f37120";
  Palette["darkOrange"] = "#ba4909";
  Palette["lightOrange"] = "#ffece0";
  Palette["black"] = "#333333";
  Palette["darkGrey"] = "#666666";
  Palette["medGrey"] = "#999999";
  Palette["altMedGrey"] = "#a8a8a8";
  Palette["grey"] = "#bbbbbb";
  Palette["lightGrey"] = "#dddddd";
  Palette["tableHeaders"] = "#e9e9e9";
  Palette["lighterGrey"] = "#f5f5f5";
  Palette["lightestGrey"] = "#f9f9f9";
  Palette["white"] = "#fff";
})(Palette || (Palette = {}));

exports.default = Palette;